import cx from 'classnames'
import { Badge as RSBadge, BadgeProps } from 'reactstrap'
import styles from './styles.module.scss'

const Badge = (props: BadgeProps) => {
  const { className, ...otherProps } = props
  return <RSBadge {...otherProps} className={cx(styles.hfBadge, className)} />
}

export default Badge
